module.exports = __webpack_public_path__ + "media/images/lp_v6_img03 (1)-4ff8f1b6b377a8f32a951df8a905ad4f.webp";